type TranslationPayload<T> = T & {
  count: number;
};

export function getTranslationParamsByPluralRules<T>(
  key: string,
  payload: TranslationPayload<T>
): [string, TranslationPayload<T>] {
  const finalKey = payload.count === 1 ? `${key}_one` : `${key}_other`;

  return [finalKey, payload];
}

const ORDINAL_SUFFIXES = {
  one: "st",
  two: "nd",
  few: "rd",
  other: "th",
};

export function getNumberOrdinalFormat(value: number, locale: string): string {
  const pluralRules = new Intl.PluralRules(locale, { type: "ordinal" });
  const type = pluralRules.select(value) as keyof typeof ORDINAL_SUFFIXES;
  const suffix = ORDINAL_SUFFIXES[type];

  return `${value}${suffix}`;
}
